import { Box, Stack } from '@mui/material';
import { Typography } from '@portals/core/src/components/Typography/Typography';
import React, { ReactElement } from 'react';

import { type Location } from './LocationsMap';

type Props = Location & {
  statusIcon: ReactElement;
};

export const LocationItem: React.FunctionComponent<Props> = ({ headline, address, statusIcon }: Props) => {
  return (
    <Box display="grid" gridTemplateColumns="min-content 1fr" flex="1">
      <Box gridColumn="1" gridRow="2">
        {statusIcon}
      </Box>
      <Box gridColumn="2" gridRow="2">
        <Stack
          spacing={{ xs: 5, md: 5, lg: 6 }}
          flex="1"
          direction={{ xs: 'column', sm: 'row', md: 'column' }}
          justifyContent="space-between"
        >
          <Stack gap={{ xs: 3, md: 5 }}>
            <Stack direction="row" justifyContent="space-between">
              <Typography variant="h5" component="div" color="text.primary">
                {headline}
              </Typography>
            </Stack>
            <Typography variant="body2" component="div" color="text.secondary">
              {address}
            </Typography>
          </Stack>
        </Stack>
      </Box>
    </Box>
  );
};
